import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Paperclip } from "lucide-react";

export function useAttachmentCounts(entityType, ids) {
  const [counts, setCounts] = useState({});
  const key = (ids || []).join(",");
  useEffect(() => {
    if (!key) { setCounts({}); return; }
    let live = true;
    client.post("/attachments/counts", { entity_type: entityType, ids: key.split(",") })
      .then(({ data }) => live && setCounts(data))
      .catch(() => {});
    return () => { live = false; };
  }, [entityType, key]);
  return counts;
}

export function AttachmentCount({ count, testid }) {
  if (!count) return null;
  return (
    <span
      title={`${count} attachment${count === 1 ? "" : "s"}`}
      data-testid={testid}
      className="inline-flex shrink-0 items-center gap-0.5 rounded-full bg-slate-100 px-1.5 py-0.5 text-[11px] font-medium text-slate-500"
    >
      <Paperclip className="h-3 w-3" />{count}
    </span>
  );
}

const batch = { pending: new Set(), cache: {}, subs: new Set(), timer: null };
const flush = () => {
  const ids = [...batch.pending];
  batch.pending.clear(); batch.timer = null;
  client.post("/attachments/counts", { entity_type: "action", ids }).then(({ data }) => {
    const at = Date.now();
    ids.forEach((id) => { batch.cache[id] = { n: data[id] || 0, at }; });
    batch.subs.forEach((f) => f());
  }).catch(() => {});
};

export function useActionAttachmentCount(id) {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!id || String(id).startsWith("sub-")) return undefined;
    const sub = () => tick((x) => x + 1);
    batch.subs.add(sub);
    const hit = batch.cache[id];
    if (!hit || Date.now() - hit.at > 20000) {
      batch.pending.add(id);
      if (!batch.timer) batch.timer = setTimeout(flush, 60);
    }
    return () => { batch.subs.delete(sub); };
  }, [id]);
  return batch.cache[id]?.n || 0;
}

export const forgetActionAttachmentCount = (id) => { delete batch.cache[id]; };
